import { Component, Input, OnInit } from "@angular/core";
import {
  CustomColumnComponent,
  SharedModule,
  DataService,
} from "@bb-vendure/admin-ui/core";
import { Observable } from "rxjs";
import { GetProductSaleDocument } from "src/generated-gql/graphql";

@Component({
  selector: "total-sale-column",
  imports: [SharedModule],
  templateUrl: "./total-sale-column.component.html",
  standalone: true,
})
export class TotalSaleColumnComponent implements CustomColumnComponent, OnInit {
  sales$: Observable<number>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.sales$ = this.dataService
      .query(GetProductSaleDocument, {
        id: this.rowItem.id,
      })
      .mapSingle((res) => {
        return res.productSale ?? 0;
      });
  }
  @Input() rowItem: {
    id: string;
  };
}
